import { useIsSuperuser } from "hooks/users"

/**
 * Whether the user may manage layouts as first-class objects (pick a starting layout, save-as-new,
 * duplicate). Superuser-only for the MVP — a regular user has one implicit layout and every dashboard
 * is just another instance of it (APP-3284). Single place to widen the rule later.
 */
export function useCanManageLayouts(): boolean {
  return useIsSuperuser()
}
